import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { chunkArray } from '@diritto/common/utils/array';
import { PromotionReplyApi } from 'api/ApiHelper';
import { promotionsQueryKey } from '@/queries/promotions/queryKey';

export const useGetPromotionLikedRepliesQueries = (promotionId: number, replyIds: string[], enabled = false) => {
  const chunkedReplyIds = useMemo(() => chunkArray(replyIds, 20), [replyIds]);
  const queries = useMemo(
    () => ({
      queries: chunkedReplyIds.map(chunkedReplyId => ({
        queryKey: promotionsQueryKey.promotionReplyLikeList(promotionId, chunkedReplyId),
        queryFn: () => PromotionReplyApi.getPromotionReplyLikes(promotionId, chunkedReplyId),
        enabled,
      })),
    }),
    [chunkedReplyIds, enabled, promotionId],
  );

  return useQueries(queries);
};
